import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

export default function LanguageRouter({ children }) {
  const { pathname } = useLocation();
  const { lang, setLang } = useLanguage();
  const urlLang = pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'el';

  useEffect(() => {
    if (urlLang !== lang) setLang(urlLang);
  }, [urlLang, lang, setLang]);

  return children;
}
